/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.marcas': 'Marcas',
  'marcas.agregarMarcas': 'Crear Marcas',
  'marcas.modificarMarcas': 'Editar Marcas',
  'marcas.marcaId': 'Marca Id',
  'marcas.empresaId': 'Empresa Id',
  'marcas.marcaDescripcion': 'Marca Descripción',
  'marcas.VerMarcas': 'Ver Marcas',
};
